<form id="order-info-form-pg-1" [formGroup]="formGroup" cleanStepPanelAccessibility>

    <!-- Code Implementation for Order Information -->
     <span #stepHeading tabindex="-1" class="sr-only">Step 1: Order info</span>

    <p-panel header="Order Information" styleClass="mb-5 panel-skew-heading" [attr.aria-label]="'Order Information Panel'">

        <div class="row mb-3-x">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-ref-num" class="form-label required-asterisk">Claim Number</label>
                <input pInputText type="text" id="order-info-ref-num" placeholder="Enter claim number"
                    class="form-control" formControlName="orderInfoRefNum"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoRefNum')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoRefNum')" class="error-label">This field
                    is mandatory</small>
            </div>
             <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label class="form-label required-asterisk">Date of Incident</label>
                <p-datepicker dateMask id="date-of-incident-date-picker" placeholder="mm/dd/yyyy" formControlName="orderInfoDate"
                    showIcon iconDisplay="input" styleClass="w-100" [maxDate]="maxDate" appendTo="body"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoDate')}" (onInput)="onDateInput($event)"/>
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoDate') && !formGroup.get('orderInfoDate')?.errors?.['maxDateExceeded']" class="error-label">This field is
                    mandatory</small>
                <small id="order-info-ref-num-error" *ngIf="formGroup.get('orderInfoDate')?.errors?.['maxDateExceeded']" class="error-label">Please enter a valid date</small>
            </div>
        @if(!isUserLinkedToAccount){
        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="order-info-account-name" class="form-label d-block required-asterisk">Account Name</label>
            <p-select formControlName="orderInfoAccountName" [options]="accountNames" optionLabel="name" optionValue="value"
                placeholder="Select account name" styleClass="w-100" (onChange)="onAccountNameSelection($event.value, true)"
                [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAccountName')}" [attr.disabled]="formGroup.get('orderInfoAccountName')?.disabled ? true : null"/>
            <small id="order-info-account-name-error" *ngIf="isError('orderInfoAccountName')" class="error-label">This field is
                mandatory</small>
        </div>
        }
        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="order-info-client-name" class="form-label d-block required-asterisk">Client Name</label>
            <p-select formControlName="orderInfoClientName" [options]="clientNames" optionLabel="name" optionValue="value"
                placeholder="Select client name" styleClass="w-100" (onChange)="onClientNameSelection($event.value)"
                [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoClientName')}" [attr.disabled]="formGroup.get('orderInfoClientName')?.disabled ? true : null"/>
            <small id="order-info-client-name-error" *ngIf="isError('orderInfoClientName')" class="error-label">This field is
                mandatory</small>
        </div>
         @if(!isUserLinkedToAccount){
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-order-owner" class="form-label d-block required-asterisk">Order Owner</label>
                <p-select formControlName="orderInfoOrderOwner" [options]="orderOwners" optionLabel="name" optionValue="value"
                    placeholder="Select user" styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoOrderOwner')}" />
                <small id="order-info-order-owner-error" *ngIf="isError('orderInfoOrderOwner')" class="error-label">This field
                    is mandatory</small>
            </div>
        }
        </div>
        <!-- @if(!isUserLinkedToAccount){
        <div class="row mb-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <label for="order-info-order-owner" class="form-label d-block required-asterisk">Order Owner</label>
                <p-select formControlName="orderInfoOrderOwner" [options]="orderOwners" optionLabel="name" optionValue="value"
                    placeholder="Select user" styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoOrderOwner')}" />
                <small id="order-info-order-owner-error" *ngIf="isError('orderInfoOrderOwner')" class="error-label">This field
                    is mandatory</small>
            </div>
        </div>
        } -->
        <div class="row mb-3">
            <div class="col-sm-12">
                <label class="form-label mb-3 required-asterisk semi-bold-text">Type of Order</label>
                <div *ngFor="let category of categories" class="d-flex mb-2 ms-3" [ngClass]="{'p-disabled' : editOrder}">
                    <p-radiobutton [inputId]="category.name" [value]="category.name" formControlName="selectedCategory"
                        [ngClass]="{'ng-invalid ng-dirty' : isError('selectedCategory')}" />
                    <label [for]="category.name" class="ms-2 pointer">
                        {{ category.description }}
                        <!-- <br />{{ category.description }} -->
                    </label>
                </div>
                <small id="order-info-ref-num-error" *ngIf="isError('selectedCategory')" class="error-label">This field
                    is mandatory</small>
            </div>
        </div>
        <!-- <div class="row mb-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label class="form-label required-asterisk">Service Level</label><br />
                <p-select formControlName="selectedLevel" [options]="levels" optionLabel="name"
                    placeholder="Select service level" styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('selectedLevel')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('selectedLevel')" class="error-label">This field is
                    mandatory</small>
            </div>
        </div> -->
        <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label class="form-label semi-bold-text">Special Handling</label><br />
                <p-checkbox formControlName="selectedLevel" inputId="order-info-special-handling-label" id="order-info-special-handling" [binary]="true" />
                <label for="order-info-special-handling-label" class="ms-2">Rush order</label>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Contact Information -->

    <p-panel header="Contact Information" styleClass="mb-5 panel-skew-heading" [attr.aria-label]="'Contact Information Panel'">
        <div formArrayName="contacts">
            <div *ngFor="let contact of contacts.controls; let i = index" [formGroupName]="i"
                [ngClass]="{'mt-2rem': i > 0}">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                            <h2 #contactHeaders tabindex="-1" class="contactListNo">
                                <span *ngIf="i<9">Contact {{ '0'+ (i + 1) }}</span>
                                <span *ngIf="i>=9">Contact {{ i + 1 }}</span>
                            </h2>
                            <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true" label="Delete" *ngIf="i>0"
                                (onClick)="showContactDeletionModal(i)" [disabled]="editOrder && !contact?.value?.isNew"></p-button>
                        </div>
                        <!--  <hr /> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                        <label for="order-info-contact-{{i}}" class="form-label d-block required-asterisk">Contact
                            Name</label>
                        <input pInputText type="text" *ngIf="!contacts.at(i).get('showContactDropdown')?.value" id="order-info-contact-{{i}}" class="w-100" placeholder="Enter name"
                            formControlName="contactInput" [ngClass]="{'ng-invalid ng-dirty' : isError('contactName', contact)}" />

                        <p-dropdown *ngIf="contacts.at(i).get('showContactDropdown')?.value" [options]="contactNames" id="order-info-contact-{{i}}" formControlName="contactDropdown" optionLabel="name" [filter]="true" filterBy="name"
                            [showClear]="true" placeholder="Enter name"  styleClass="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactName', contact)}"
                            (onChange)="onDropdownChange($event,i)">
                        
                            <ng-template pTemplate="selectedItem" let-selectedOption>
                                <div *ngIf="selectedOption && !selectedOption.isSpecial">{{ selectedOption.name }}</div>
                                <div *ngIf="selectedOption?.isSpecial" class="text-muted">Enter name</div>
                            </ng-template>
                        
                            <ng-template let-option pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <div>{{ option.name }}</div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <div class="p-2 text-primary cursor-pointer p-multiSelectFooter" (click)="onDropdownChange($event,i)">
                                    Don’t see your results? Click here to add more.
                                </div>
                                </ng-template>
                            
                        </p-dropdown>
                        <small id="order-info-ref-num-error" *ngIf="isError('contactName', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-8 col-md-4 col-lg-2 mb-3 mb-sm-0 pe-1">
                        <label for="order-info-contact-phone-{{i}}"
                            class="form-label d-block required-asterisk">Phone</label>
                        <p-inputmask mask="(999) 999-9999" id="order-info-contact-phone-{{i}}" placeholder="Enter phone"
                            formControlName="contactPhone" class="w-100 phone-inputmask"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactPhone', contact)}" autocomplete="new-password"/>
                        <small id="order-info-ref-num-error" *ngIf="isError('contactPhone', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-4 col-md-2 col-lg-1 mb-3 mb-sm-0 ps-1">
                        <label for="order-info-contact-phone-extn-{{i}}" class="form-label d-block">Extension</label>
                        <input pInputText type="text" id="order-info-contact-phone-extn-{{i}}" placeholder="Enter"
                            formControlName="contactPhoneExtn" class="w-100" />
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="order-info-contact-email-{{i}}"
                     class="form-label d-block required-asterisk">Email</label>
                    <input pInputText type="email" id="order-info-contact-email-{{i}}" class="w-100"
                    placeholder="Enter email" formControlName="contactEmail"
                         [ngClass]="{'ng-invalid ng-dirty' : isError('contactEmail', contact)}" />
                    <small id="order-info-ref-num-error" *ngIf="isError('contactEmail', contact) && contact?.get('contactEmail')?.hasError('required')"
                        class="error-label">This field is mandatory</small>
                    <small *ngIf="contact?.get('contactEmail')?.hasError('email')" class="error-label">Please
                        enter a valid email address.</small>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                        <label for="order-info-contact-title-{{i}}"
                            class="form-label d-block required-asterisk">Title</label>
                        <p-select aria-label="title" formControlName="contactTitle" id="order-info-contact-title-{{i}}" [options]="titles"
                            optionLabel="title" placeholder="Select title"
                            (onChange)="onTitleSelection($event.value.value, i)" styleClass="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactTitle', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactTitle', contact)"
                            class="error-label">This
                            field is mandatory</small>
                        <!-- {{contact?.get('contactTitle')?.value.value}} -->
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="formGroup?.get('selectedCategory')?.value == 'subpoena-to-be-prepared' && contact?.get('contactTitle')?.value?.value == 'attorney'">
                        <label for="order-info-contact-bar-no-{{i}}" class="form-label d-block required-asterisk">Bar
                            Number</label>
                        <input pInputText type="text" id="order-info-contact-bar-no-{{i}}"
                            placeholder="Enter attorney's bar number" formControlName="contactBarNo" class="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactBarNo', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactBarNo', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                </div>
                <!-- <div class="row mb-3"
                    *ngIf="formGroup?.get('selectedCategory')?.value == 'subpoena-to-be-prepared' && contact?.get('contactTitle')?.value?.value == 'attorney'">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="order-info-contact-bar-no-{{i}}" class="form-label d-block required-asterisk">Bar
                            Number</label>
                        <input pInputText type="text" id="order-info-contact-bar-no-{{i}}"
                            placeholder="Enter attorney's bar number" formControlName="contactBarNo" class="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactBarNo', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactBarNo', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                </div> -->
            </div>
        </div>
        <p-button aria-label="Add New Contact" label="Add New Contact" styleClass="px-0" icon="pi pi-plus"
            (onClick)="addNewContact()" [link]="true" />
        <!-- Contact Div Appended Here on Add Button -->
    </p-panel>

    <!-- Code Implementation for Billing Information -->

    <p-panel header="Billing Information" styleClass="mb-5 panel-skew-heading" [attr.aria-label]="'Billing Information Panel'">
        <div class="row">
            <!-- <div class="col-sm-3 mb-3 mb-sm-0">
                <label class="form-label d-block">Title</label>
                <p-select formControlName="orderInfoBillTo" [options]="billers" optionLabel="name"
                    placeholder="{{ billers[0].name }}" styleClass="w-100" />
            </div> -->
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-billing-contact-name" class="form-label d-block required-asterisk">Bill To</label>
                <input pInputText type="text" *ngIf="!formGroup?.get('showOrderInfoBillToDropdown')?.value" id="order-info-billing-contact-name" class="w-100" placeholder="Enter Bill to name"
                    formControlName="orderInfoBillToInput" [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoBillTo')}" />

                <p-dropdown *ngIf="formGroup?.get('showOrderInfoBillToDropdown')?.value" [options]="billerNames" id="order-info-billing-contact-name" 
                    formControlName="orderInfoBillToDropdown" optionLabel="name" [filter]="true" filterBy="name"
                    [showClear]="true" placeholder="Select bill to"  styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoBillTo')}"
                    (onChange)="onBillerChange($event)">
                
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                            <div *ngIf="selectedOption">{{ selectedOption.name }}</div>
                            <div *ngIf="!selectedOption" class="text-muted">Enter Bill to name</div>
                        </div>
                    </ng-template>
            
                    <ng-template let-option pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>{{ option.name }}</div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="footer">
                                <div class="p-2 text-primary cursor-pointer p-multiSelectFooter" (click)="onBillerChange($event)">
                                    Don’t see your results? Click here to add more.
                                </div>
                                </ng-template>
            
                </p-dropdown>  
                <small id="order-info-bill-to-error" *ngIf="isError('orderInfoBillTo')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-bill-to-email" class="form-label d-block required-asterisk">Billing Email Address</label>
                <input pInputText type="email" id="order-info-bill-to-email" class="form-control"
                    formControlName="orderInfoBillToEmail" placeholder="Enter billing email address" [attr.disabled]="true"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoBillToEmail')}" />
                <small id="order-info-ref-num-error"
                    *ngIf="isError('orderInfoBillToEmail') && formGroup?.get('orderInfoBillToEmail')?.hasError('required')"
                    class="error-label">This field is mandatory</small>
                <small *ngIf="formGroup?.get('orderInfoBillToEmail')?.hasError('email')" class="error-label">Please
                    enter a valid email address.</small>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-billing-contact-name" class="form-label d-block required-asterisk">Adjuster Name</label>
                <input pInputText type="text" *ngIf="!formGroup?.get('showAdjusterDropdown')?.value" id="order-info-billing-contact-name" class="w-100" placeholder="Enter adjuster name"
                    formControlName="adjusterInput" [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAdjusterName')}" />

                <p-dropdown *ngIf="formGroup?.get('showAdjusterDropdown')?.value" [options]="adjusterNames" id="order-info-billing-contact-name" 
                    formControlName="adjusterDropdown" optionLabel="name" [filter]="true" filterBy="name"
                    [showClear]="true" placeholder="Enter adjuster name"  styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAdjusterName')}"
                    (onChange)="onAdjusterChange($event)">
                
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                            <div *ngIf="selectedOption">{{ selectedOption.name }}</div>
                            <div *ngIf="!selectedOption" class="text-muted">Enter adjuster name</div>
                        </div>
                    </ng-template>
            
                    <ng-template let-option pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>{{ option.name }}</div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="footer">
                                <div class="p-2 text-primary cursor-pointer p-multiSelectFooter" (click)="onAdjusterChange($event)">
                                    Don’t see your results? Click here to add more.
                                </div>
                                </ng-template>
            
                </p-dropdown>
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAdjusterName')" class="error-label">This field is
                    mandatory</small>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-bill-to-email" class="form-label d-block">Adjuster Email Address</label>
                <input pInputText type="email" id="order-info-bill-to-email" class="form-control"
                    formControlName="orderInfoAdjusterEmail" placeholder="Enter adjuster email address" [attr.disabled]="true"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAdjusterEmail')}" />
                <!-- <small id="order-info-ref-num-error"
                    *ngIf="isError('orderInfoAdjusterEmail') && formGroup?.get('orderInfoAdjusterEmail')?.hasError('required')"
                    class="error-label">This field is mandatory</small> -->
                <small id="order-info-ref-email-error" *ngIf="formGroup?.get('orderInfoAdjusterEmail')?.hasError('email')" class="error-label">Please
                    enter a valid email address.</small>
            </div>

            <!-- CASE MATTER FIELD (only when Client = Walmart) -->
            @if (formGroup.get('caseMatter')?.enabled) {
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="order-info-case-matter" class="form-label d-block required-asterisk">
                Case Matter
            </label>
            <input
                pInputText
                type="text"
                id="order-info-case-matter"
                class="form-control"
                placeholder="Enter case matter number"
                formControlName="caseMatter"
                maxlength="100"
                [ngClass]="{ 'ng-invalid ng-dirty': isError('caseMatter') }" />
        
            <small
                id="order-info-case-matter-error"
                *ngIf="isError('caseMatter')"
                class="error-label">
                This field is mandatory
            </small>
            </div>
            }
        </div>
    </p-panel>

    <!-- Code Implementation for Delivery Information -->

    <p-panel header="Delivery Information" styleClass="mb-5 panel-skew-heading" [attr.aria-label]="'Delivery Information Panel'">
        <div class="row mb-4">
            <div class="col-sm-12">
                <label class="form-label mb-3 semi-bold-text">Is special delivery required for the request?</label>
                <div class="d-flex justify-content-start">
                <span class="mb-2 ms-3">
                    <p-radiobutton inputId="special-delivery-yes" [value]="true" formControlName="isSpecialDeliveryRequired" />
                    <label for="special-delivery-yes" class="ms-2 pointer">Yes</label>
                </span>
                <span class="mb-2 ms-3">
                    <p-radiobutton inputId="special-delivery-no" [value]="false" formControlName="isSpecialDeliveryRequired" />
                    <label for="special-delivery-no" class="ms-2 pointer">No</label>
                </span>
            </div>
            </div>
        </div>
        @if(formGroup.get('isSpecialDeliveryRequired')?.value === true) {
        <div class="row mb-4">
            <div class="col-sm-12 medium-text">
                If you need physical copy / CDs then fill in details below
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-attention-to" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Attention To</label>
                <input pInputText type="text" id="order-info-attention-to" placeholder="Enter attention to"
                    class="form-control" formControlName="orderInfoAttentionTo"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionTo')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionTo')" class="error-label">This
                    field is mandatory</small>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-attention-to-firm-name" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Firm Name</label>
                <input pInputText type="text" id="order-info-attention-to-firm-name" placeholder="Enter firm name"
                    class="form-control" formControlName="orderInfoAttentionToFirmName"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmName')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmName')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-8 col-md-4 col-lg-2 mb-3 pe-1">
                <label for="order-info-attention-to-firm-phone" class="form-label d-block">Phone</label>
                <p-inputmask mask="(999) 999-9999" id="order-info-attention-to-firm-phone" placeholder="Enter phone"
                    formControlName="orderInfoAttentionToFirmPhone" class="w-100 phone-inputmask" autocomplete="new-password"/>
            </div>
            <div class="col-4 col-md-2 col-lg-1  mb-3 ps-1">
                <label for="order-info-attention-to-firm-phone-extension" class="form-label d-block">Extension</label>
                <input pInputText type="text" id="order-info-attention-to-firm-phone-extension" placeholder="Enter"
                    formControlName="orderInfoAttentionToFirmPhoneExtn" class="w-100" />
            </div>
            <div class="col-md-6 col-lg-3 d-none d-md-block"></div>
        <!-- </div>
        <div class="row mb-3"> -->
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-firm-address" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Street Address</label>
                <input pInputText type="text" id="order-info-firm-address" placeholder="Enter street address"
                    class="form-control" formControlName="orderInfoAttentionToFirmAddress"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmAddress')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmAddress')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-attention-to-firm-city" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">City</label>
                <input pInputText type="text" id="order-info-attention-to-firm-city" placeholder="Enter city"
                    class="form-control" formControlName="orderInfoAttentionToFirmCity"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmCity')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmCity')"
                    class="error-label">This field is mandatory</small>

            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-attention-to-firm-state" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">State</label>
                <p-select formControlName="orderInfoAttentionToFirmState" [options]="states" optionLabel="name"
                    placeholder="Select state" styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmState')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmState')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                <label for="order-info-attention-to-firm-zip" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Zip</label>
                <input pInputText type="text" id="order-info-attention-to-firm-zip" placeholder="Enter zip"
                    formControlName="orderInfoAttentionToFirmZip" class="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmZip')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmZip')"
                    class="error-label">This field is mandatory</small>
            </div>
        </div>
        }
    </p-panel>

    <!-- Code Implementation for Attachments -->
    <app-attachments [attachments]="attachments" [editOrder]="editOrder" [attachmentForm]="formGroup" [parentId]="'orderInfo'" [instructionText]="'Upload all Order-level attachments (e.g., POA, death certificate, complaint copy, LOR). Provider-level documents will be added in subsequent pages.'" 
    [instructionText2]="'Ensure each uploaded file is under 100 MB and in an accepted format, such as PDF, Excel (XLS/XLSX), CSV, or Word (DOC/DOCX).'"
    [documentType]="'OrderDocumentCode'">
    </app-attachments>
  
    <!-- Code Implementation for Special Instructions -->

    <p-panel header="Special Instructions" styleClass="panel-skew-heading" [attr.aria-label]="'Special Information Panel'">
        <div class="row mb-0">
            <div class="col-sm-12">
                <textarea class="w-100" pTextarea id="order-info-special-instructions" placeholder="Enter text here"
                    formControlName="orderInfoSpecialInstructions" sanitizePaste></textarea>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Next Step Button -->

    <!-- <div class="row mb-3">
        <div class="col-sm-12 text-end">
            <hr/>
            <p-button label="Next Step" />
        </div>
    </div> -->

</form>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'"
    (acceptModalClick)="confirmContactDeletion()" (rejectModalClick)="showDeleteModal = false">
    <span>Are you sure want to delete this?</span>
</app-modal>
<p-toast position="top-center" severity="warn" />